<template>
  <div>
    <button
      class="action-button"
      :class="{
        'background-green': color === 'green'
      }"
      @click="$emit('click')"
    >
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    color: { type: String, default: '' }
  }
}
</script>

<style scoped>
.action-button {
  border: solid 1px;
  border-color: black;
  font-style: bold;
  border-radius: 4px;
}

.background-green {
  background-color: #43dbae;
}
</style>